const prefix = 'simber'

class LocalStorage {
  get(key, defaultValue = null) {
    const data = localStorage.getItem(`${prefix}_${key}`)
    if (data === undefined) return defaultValue
    let value
    try {
      value = JSON.parse(data)
    } catch (err) {
      console.error('error reading storage key:', `${prefix}_${key}`)
      value = null
    }
    if (value === undefined) return defaultValue
    return value || defaultValue
  }

  set(key, value) {
    if (value === undefined || value === null) {
      localStorage.removeItem(`${prefix}_${key}`)
    } else {
      const data = JSON.stringify(value)
      localStorage.setItem(`${prefix}_${key}`, data)
    }
  }

  remove(key) {
    localStorage.removeItem(`${prefix}_${key}`)
  }
}

export const storage = new LocalStorage()
